import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KucniBroj, NaseljenoMesto, Opstina } from 'app/models/features/rgz/rgz.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RgzService {
  api: string = environment.rgzApiUrl;

  constructor(private http: HttpClient) { }

  dajOpstine(): Observable<Opstina[]> {
    return this.http.get<Opstina[]>(`${this.api}/opstina`);
  }

  async dajNaseljenaMesta(maticniBrojOpstine: string): Promise<NaseljenoMesto[]> {
    return await this.http.get<NaseljenoMesto[]>(`${this.api}/naselje/${maticniBrojOpstine}`).toPromise();
  }

  async dajUlice(maticniBrojNaselja: string): Promise<any> {
    return await this.http.get<any>(`${this.api}/ulica/${maticniBrojNaselja}`).toPromise();
  }

  async dajKucneBrojeve(maticniBrojUlice: string): Promise<KucniBroj[]> {
    return await this.http.get<KucniBroj[]>(`${this.api}/kucniBroj/${maticniBrojUlice}`).toPromise();
  }
}
